import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApiClient } from '@/lib/api';

import type { SupportRequest } from '../types';
import { supportQueryKeys } from '../utils/queryKeys';

export const LIST_REFETCH_INTERVAL_MS = 60_000;

export const useSupportRequests = (): UseQueryResult<
  SupportRequest[],
  Error
> => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: [...supportQueryKeys.list()],
    queryFn: () => apiClient.getSupportRequests(),
    refetchInterval: LIST_REFETCH_INTERVAL_MS,
    // Transient poll failures must retry silently and keep last-good data —
    // never surface a global error toast (decision #14).
    meta: { ignoreError: true },
    // ignoreError silences the snackbar; keep the boundary silent too.
    throwOnError: false,
  });
};

export default useSupportRequests;
